/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PolicyRole {
  /**
   * Unique Id for the Policy Role
   */
  policyRoleId?: string;
  /**
   * Indicates the type of Role
   */
  policyRoleTypeCode?: string;
  /**
   * Policy Role name
   */
  policyRoleName?: string;
  /**
   * Date when the role is effective
   */
  startDate?: Date;
  /**
   * Date when the role is expired
   */
  endDate?: Date;
  /**
   * Indicates if the role is the main role
   */
  mainRoleInd?: boolean;
  /**
   * Contains observations or additional information for the role
   */
  policyRoleObs?: string;
  /**
   * checks if the role is inactive
   */
  inactiveInd?: boolean;
  /**
   * Relates the document identity with the correspondent Client
   */
  clientId?: string;
}
